import { gql } from '@apollo/client';

export const GHOST_AUTHOR_FRAGMENT = gql`
  fragment GhostAuthor on Author {
    id
    slug
    name
    profileImage
    location
    url
    bio
    website
    twitter
    instagram
    linkedin
  }
`;
